package diana.soleil.design.iraniancanadienbazzar.core.designsystem.component

import androidx.compose.foundation.horizontalScroll
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.rememberScrollState
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.input.KeyboardType
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.theme.AppTheme

/**
 * A city text input with tap-to-fill suggestion chips beneath it. The DS stays data-agnostic:
 * [suggestionsFor] is supplied by the caller (backed by the metro municipality list), so this
 * component has no dependency on the domain model. Suggestions render as a horizontally-scrollable
 * chip row and hide once the query matches (the suggestions lambda returns empty on an exact match).
 */
@Composable
fun CityField(
    value: String,
    onValueChange: (String) -> Unit,
    label: String,
    placeholder: String,
    suggestionsFor: (String) -> List<String>,
    modifier: Modifier = Modifier,
    isError: Boolean = false,
    supportingText: String? = null,
) {
    Column(
        modifier = modifier.fillMaxWidth(),
        verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm),
    ) {
        AppTextField(
            value = value,
            onValueChange = onValueChange,
            label = label,
            placeholder = placeholder,
            singleLine = true,
            keyboardType = KeyboardType.Text,
            isError = isError,
            supportingText = supportingText,
            modifier = Modifier.fillMaxWidth(),
        )
        val suggestions = suggestionsFor(value)
        if (suggestions.isNotEmpty()) {
            Row(
                modifier = Modifier.horizontalScroll(rememberScrollState()),
                horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm),
            ) {
                suggestions.forEach { city ->
                    AppChip(label = city, leadingIcon = "location_on", onClick = { onValueChange(city) })
                }
            }
        }
    }
}
